import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ItemCardCustomization, ItemCardCustomizationType } from '@/models';
import uniq from 'lodash/uniq';
import { nextTick } from 'process';

@Component({
  name: 'CmgMealBuilderItemSelectorCardMobileCustomizationsOverlay',
})
export default class CmgMealBuilderItemSelectorCardMobileCustomizationsOverlay extends Vue {
  @Prop({ default: false, type: Boolean })
  active!: boolean;

  @Prop({ required: true, type: Array })
  customizations!: ItemCardCustomization[];

  showTooltip = false;

  get kebabMenuImageUrl(): string {
    return this.$appStore.state.cms.images.icons.kebabMenu.default;
  }

  // Puts the Normal option first
  get sortedCustomizations(): ItemCardCustomization[] {
    const defaultCustomization = this.customizations.find(customization => customization.type == ItemCardCustomizationType.Normal);
    return defaultCustomization ? uniq([defaultCustomization, ...this.customizations]) : this.customizations;
  }

  get messageArrowsImageUrl(): string {
    return this.$appStore.state.cms.images.icons.swipeArrows.default;
  }

  onStartCustomization() {
    nextTick(() => {
      (this.$refs.sortedCustomizations as HTMLElement[])[0].focus();
    });
  
    this.$emit('start-customization');
    this.showTooltip = false;
  }

  onEndCustomization() {
    nextTick(() => {
      (this.$refs.kebabMenuContainer as HTMLElement).focus();
    });

    this.$emit('end-customization');
  }

  onSelectCustomization(customization: ItemCardCustomization) {
    this.$emit('select-customization', customization);
  }

  onMouseOverKebab(): void {
    this.showTooltip = true;
  }

  onMouseOutKebab(): void {
    this.showTooltip = false;
  }
}
